import {translate} from 'views/module';

const generateFilterOptions = () => {
  const filterOptions = {};

  filterOptions.caregiverName = {
    key: 'caregiverName',
    label: translate('caregiver.CaregiverList.Filter.CaregiverName'),
    rank: 0,
    type: 'text',
    options: null,
    canBeEmpty: false,
  };

  filterOptions.status = {
    key: 'status',
    label: translate('caregiver.CaregiverList.Filter.Status'),
    rank: 1,
    options: Object.entries(translate('caregiver.Status'))
        .reduce((acc, [key, value], index) => {
          acc[key] = {
            label: value.Title,
            color: value.Color,
            rank: index,
            key: key,
          };
          return acc;
        }, {}),
    canBeEmpty: false,
    multiSelect: true,
    defaultSelected: ['ACTIVE', 'PROFILE_REVIEW'],
  };

  filterOptions.location = {
    key: 'location',
    label: translate('caregiver.CaregiverList.Filter.Location'),
    rank: 2,
    options: {
      enabled: {
        label: translate('caregiver.CaregiverList.Filter.MapEnabled'),
        rank: 0,
        key: 'enabled',
      },
      disabled: {
        label: translate('caregiver.CaregiverList.Filter.MapDisabled'),
        rank: 1,
        key: 'disabled',
      },
    },
    canBeEmpty: false,
  };

  filterOptions.certification = {
    key: 'certification',
    label: translate('caregiver.CaregiverList.Filter.Certification'),
    rank: 3,
    options: {
      psw: {
        label: 'PSW',
        rank: 0,
        key: 'psw',
      },
      dsw: {
        label: 'DSW',
        rank: 1,
        key: 'dsw',
      },
      nursing: {
        label: 'Nursing',
        rank: 2,
        key: 'nursing',
      },
      firstAid: {
        label: 'First Aid',
        rank: 3,
        key: 'firstAid',
      },
      cpr: {
        label: 'CPR',
        rank: 4,
        key: 'cpr',
      },
    },
    canBeEmpty: false,
    multiSelect: true,
  };

  filterOptions.languages = {
    key: 'languages',
    label: translate('caregiver.CaregiverList.Filter.Languages'),
    rank: 4,
    options: {
      'Arabic': {label: 'Arabic', rank: 0, key: 'Arabic'},
      'Bengali': {label: 'Bengali', rank: 1, key: 'Bengali'},
      'Cantonese': {label: 'Cantonese', rank: 2, key: 'Cantonese'},
      'Cree': {label: 'Cree', rank: 3, key: 'Cree'},
      'Dutch': {label: 'Dutch', rank: 4, key: 'Dutch'},
      'English': {label: 'English', rank: 5, key: 'English'},
      'French': {label: 'French', rank: 6, key: 'French'},
      'German': {label: 'German', rank: 7, key: 'German'},
      'Greek': {label: 'Greek', rank: 8, key: 'Greek'},
      'Gujarati': {label: 'Gujarati', rank: 9, key: 'Gujarati'},
      'Haitian Creole': {label: 'Haitian Creole', rank: 10, key: 'Haitian Creole'},
      'Hebrew': {label: 'Hebrew', rank: 11, key: 'Hebrew'},
      'Hindustani': {label: 'Hindustani', rank: 12, key: 'Hindustani'},
      'Hungarian': {label: 'Hungarian', rank: 13, key: 'Hungarian'},
      'Ilocano': {label: 'Ilocano', rank: 14, key: 'Ilocano'},
      'Italian': {label: 'Italian', rank: 15, key: 'Italian'},
      'Japanese': {label: 'Japanese', rank: 16, key: 'Japanese'},
      'Korean': {label: 'Korean', rank: 17, key: 'Korean'},
      'Malayalam': {label: 'Malayalam', rank: 18, key: 'Malayalam'},
      'Mandarin': {label: 'Mandarin', rank: 19, key: 'Mandarin'},
      'Persian': {label: 'Persian', rank: 20, key: 'Persian'},
      'Polish': {label: 'Polish', rank: 21, key: 'Polish'},
      'Portuguese': {label: 'Portuguese', rank: 22, key: 'Portuguese'},
      'Punjabi': {label: 'Punjabi', rank: 23, key: 'Punjabi'},
      'Romanian': {label: 'Romanian', rank: 24, key: 'Romanian'},
      'Russian': {label: 'Russian', rank: 25, key: 'Russian'},
      'Serbo-Croatian': {label: 'Serbo-Croatian', rank: 26, key: 'Serbo-Croatian'},
      'Somali': {label: 'Somali', rank: 27, key: 'Somali'},
      'Spanish': {label: 'Spanish', rank: 28, key: 'Spanish'},
      'Swahili': {label: 'Swahili', rank: 29, key: 'Swahili'},
      'Tagalog': {label: 'Tagalog', rank: 30, key: 'Tagalog'},
      'Tamil': {label: 'Tamil', rank: 31, key: 'Tamil'},
      'Telugu': {label: 'Telugu', rank: 32, key: 'Telugu'},
      'Turkish': {label: 'Turkish', rank: 33, key: 'Turkish'},
      'Ukrainian': {label: 'Ukrainian', rank: 34, key: 'Ukrainian'},
      'Vietnamese': {label: 'Vietnamese', rank: 35, key: 'Vietnamese'},
    },
    canBeEmpty: false,
    multiSelect: true,
  };
  return filterOptions;
};

export {
  generateFilterOptions,
};
